import forDevice from '../../hoc/for-device';
import PostListItemImageDesktop from './post-list-item-image-desktop';
import PostListItemImageMobile from './post-list-item-image-mobile';

export default forDevice(PostListItemImageMobile, PostListItemImageDesktop);
